var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchInput',{ref:"search",attrs:{"id":_vm.id,"label":_vm.label,"clear-button-label":_vm.clearButtonLabel,"submit-button-label":_vm.submitButtonLabel,"submit-button-icon":_vm.submitButtonIcon,"direction":_vm.direction},on:{"submit_button_search":_vm.submit_button_search,"clear_button_search":_vm.clear_button_search}})
}
var staticRenderFns = []

export { render, staticRenderFns }